import { useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import { ThemeProvider } from '@mui/material/styles';

import theme from '../../theme';
import { subscribeToErrorNotices, type ErrorNotice } from '../api/errorNotices';

// Clears the ConsentBanner (fixed, bottom, z-1400) and the sidebar drawer.
const SNACKBAR_OFFSET = 96;

/**
 * Renders whatever the app-wide error channel publishes.
 *
 * Mounted from contexts.tsx, which sits ABOVE App's ThemeProvider, so it
 * carries the theme itself — otherwise the toast would render in MUI's default
 * palette on a page where everything else is branded.
 */
export default function GlobalErrorSnackbar() {
  const [notice, setNotice] = useState<ErrorNotice | null>(null);

  useEffect(() => subscribeToErrorNotices(setNotice), []);

  return (
    <ThemeProvider theme={theme}>
      <Snackbar
        // Keying on the notice id restarts the auto-hide timer when a second,
        // different failure arrives while the first is still on screen.
        key={notice?.id}
        open={!!notice}
        autoHideDuration={8000}
        onClose={(_event, reason) => {
          if (reason !== 'clickaway') setNotice(null);
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ bottom: { xs: SNACKBAR_OFFSET, sm: SNACKBAR_OFFSET } }}
      >
        <Alert severity="error" variant="filled" onClose={() => setNotice(null)} sx={{ maxWidth: 520 }}>
          {notice?.message}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}
